import { APICore } from "./apiCore";

const api = new APICore()

function listEmployees(params:any): any{
    const baseUrl = "/staff"
    return api.get(baseUrl,params)
}

function getEmployee(id:string): any{
    const baseUrl = `/staff/${id}`
    return api.get(baseUrl,{})
}

function addEmployee(params:any): any{
    const baseUrl=("/staff")
    return api.create(baseUrl,params)
}

function updateEmployee(params:any): any{
    const baseUrl=("/staff")
    return api.update(baseUrl,params)
}
function deleteEmployee(params:any): any{
    const baseUrl=("/staff")
    return api.delete(baseUrl,params)
}

export {listEmployees,getEmployee,addEmployee,updateEmployee,deleteEmployee}
